/*
 * Copyright (c) 2023
 * 
 * Created Date: Monday, September 25th 2023, 9:26:40 am
 * Author: 🫰Aris Bimas Nugroho
 * 
 */
import React from 'react'

export default function IconRequired({ text }) {
    return (
        <span className='icon-required'>{text}</span>
    )
}
